export default __webpack_public_path__ + "static/media/demand.a2b0c2e2.svg";